import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/style.css";
import App from "./app/App";
import { onStaticPage } from "./seo/paths";

/* A prerendered marketing page (/industries/…/, /ar/…) opened with an app route (#/login) continues in the app
 * document at "/" (links clicked later are handled in AppRoutes). */
if (onStaticPage() && /^#\/./.test(window.location.hash)) window.location.replace("/" + window.location.hash);

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
